import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const PWAInstallModal = ({ isOpen, toggle, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="md"
      style={{ zIndex: 10000 }}
    >
      <ModalHeader toggle={toggle}>
        <h5 className="fw-bold mb-0">Install App on iOS</h5>
      </ModalHeader>
      <ModalBody className="p-4">
        <div className="text-center">
          <div className="row g-3">
            <div className="col-12">
              <div className="d-flex align-items-center p-3 border rounded-3 bg-light">
                <div className="me-3">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      transform: "rotate(-90deg)",
                    }}
                  >
                    <span className="mdi mdi-export fs-5"></span>
                  </div>
                </div>
                <div className="text-start">
                  <h6 className="mb-1 fw-bold">Step 1: Tap Share</h6>
                  <p className="mb-0 text-muted small">
                    Click the Share button of your browser.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex align-items-center p-3 border rounded-3 bg-light">
                <div className="me-3">
                  <div
                    className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <span className="mdi mdi-plus fs-5"></span>
                  </div>
                </div>
                <div className="text-start">
                  <h6 className="mb-1 fw-bold">Step 2: Add to Home Screen</h6>
                  <p className="mb-0 text-muted small">
                    Scroll down and Click "Add to Home Screen"
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex align-items-center p-3 border rounded-3 bg-light">
                <div className="me-3">
                  <div
                    className="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <span className="mdi mdi-check fs-5"></span>
                  </div>
                </div>
                <div className="text-start">
                  <h6 className="mb-1 fw-bold">Step 3: Tap Add</h6>
                  <p className="mb-0 text-muted small">
                    Confirm by clicking "Add" in the top right corner
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-3 text-center">
          <Button color="primary" onClick={onClose} className="px-4">
            Got it!
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PWAInstallModal;
